/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForCost extends models.GovernanceConfigurationBase {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForCost.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForCost>): GovernanceConfigurationBaseForCost {
        let obj = Object.assign(new GovernanceConfigurationBaseForCost(), model);
        GovernanceConfigurationBaseForCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForCost>): GovernanceConfigurationBaseForCost {
        if (!model) return null;
        return GovernanceConfigurationBaseForCost.newInstance(<GovernanceConfigurationBaseForCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForCost) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForCost): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
    }

    /**
     * Notifications Settings For Cost
     */
    notifications: models.ConfigurationForNotifications;

}
